export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20art%20background%20with%20flowing%20organic%20shapes%20and%20deep%20crimson%20tones%2C%20swirling%20ink-like%20textures%20in%20dark%20red%20and%20charcoal%20black%2C%20dramatic%20contrast%2C%20atmospheric%20cinematic%20lighting%2C%20subtle%20tentacle-inspired%20abstract%20forms%2C%20no%20text%2C%20artistic%20composition&width=1920&height=1080&seq=hero-bg-2026-01&orientation=landscape"
          alt="触手漫画背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs font-medium text-primary-300 whitespace-nowrap">触手题材 · 每日更新</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              触手漫画
              <br />
              <span className="text-primary-300">免费在线阅读平台</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 mt-6 leading-relaxed max-w-xl">
              触手漫画网专注触手题材漫画免费在线阅读，支持下拉式畅快浏览体验。
              海量触手漫画全集实时更新，无需下载即可在线看喜欢的触手漫画。
              每日精选热门连载与经典完结作品，满足各类读者的口味需求，
              让每一次阅读都成为沉浸式的视觉享受。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">2000+</div>
                <div className="text-xs text-white/60 mt-1">海量漫画资源</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">每日更新</div>
                <div className="text-xs text-white/60 mt-1">实时追更不等待</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">完全免费</div>
                <div className="text-xs text-white/60 mt-1">无需注册即可畅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line text-lg w-5 h-5 flex items-center justify-center"></i>
                开始阅读
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-8 py-3 border border-white/30 hover:border-white/60 text-white font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-timer-line text-lg w-5 h-5 flex items-center justify-center"></i>
                最新更新
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20manga-style%20illustration%20with%20dark%20atmospheric%20scene%2C%20flowing%20organic%20tentacle-like%20forms%20in%20deep%20crimson%20and%20onyx%20black%2C%20cinematic%20composition%20with%20dramatic%20lighting%2C%20mysterious%20and%20elegant%20art%20style%2C%20no%20text%2C%20high%20contrast%2C%20dark%20aesthetic&width=800&height=1000&seq=hero-visual-2026-01&orientation=portrait"
                alt="触手漫画精选主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2">
                  <span className="px-2.5 py-0.5 bg-primary-500/80 text-white text-xs font-medium rounded-full whitespace-nowrap">热门精选</span>
                  <span className="text-white/80 text-xs">触手题材漫画每日甄选</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}